import { generatePath } from 'react-router-dom'

export const router = (path: string, params?: { [key: string]: string | null }) => {
  return generatePath(path, params)
}

export const routesPath = {
  legals: '/:locale/legals',
  privacy: '/:locale/privacy',
  root: '/:locale/:slug',
  modify: '/:locale/edit/:id',
  cancel: '/:locale/cancel/:id',
  home: '/:locale',
  notFound: '*',
}
